import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xd955m9fpf: FaireBrandEntity = {
  token: "b_xd955m9fpf",
  type: "brand",
  name: "Perimade & Co. LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/e8db229925ae495db62bee4bab4d65dc3243f2df437446816cf7b7e0f1bafbea.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7f2998585b23ea32c43e0c4cde1dac24f99bc362084bcc5a0309f34b6f7381b7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e8db229925ae495db62bee4bab4d65dc3243f2df437446816cf7b7e0f1bafbea.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7f2998585b23ea32c43e0c4cde1dac24f99bc362084bcc5a0309f34b6f7381b7.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 563,
  isTopShop: true,
  isInsider: true,
  description:
    "Our Brand\nPERIMADE & CO. is an American jewelry designer headquartered in Chicago. We make and sell couple's jewelry, sterling silver, crystal, stationery, personal accessories, and leather goods at affordable prices.\n\nYour Jewelry\nAll PERIMADE’s jewelry is made from solid 925 sterling silver or other high quality material. Our artisans create all our jewlery in our own workshop to ensure our customers getting the perfect products at affordable prices.\n\nA Thing Of Beauty Is A Joy Forever\nWelcome to our little shop, where you can find personalized jewelry and more, for you and your loved ones. Thanks again for visiting and have fun shopping at PERIMADE & CO.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:05.334Z",
    importedBy: "entity-db-cli",
  },
};
